import { useEffect, useState } from 'react';
import { v4 } from 'uuid';
import { useNavigate, useParams } from 'react-router-dom';

import { parsePayloadFromJWT } from '../../utils/helper';
import api from '../../api';
import { LoadingScreen } from '../loadingScreen/LoadingScreen';

import Home from '../home/Home';

const Main = () => {
    const [showHomePage, setShowHomePage] = useState<boolean>(false);
    const navigate = useNavigate();
    const { tokenId } = useParams();
    const localAuthToken = localStorage.getItem('api_Token');

    useEffect(() => {
        const handleApiError = (error: any) => {
            if (error.response?.status === 410) {
                navigate('/expired');
            } else {
                navigate('/');
            }
        };

        const fetchData = async () => {
            try {
                if (!tokenId) {
                    throw new Error('Invalid token');
                }

                if (localAuthToken) {
                    const smartAuth = parsePayloadFromJWT(localAuthToken);
                    if (smartAuth.token === tokenId) {
                        setShowHomePage(true);
                        return;
                    }
                }

                const response = await api.get(`/contact/${tokenId}`);
                if (response.status !== 200) {
                    throw new Error('Invalid contact');
                }

                await fetchAuth(tokenId);
            } catch (error) {
                handleApiError(error);
            }
        };

        fetchData();
    }, [navigate, tokenId, localAuthToken]);

    const fetchAuth = async (tokenId: string) => {
        const response = await api.get(`/contact/${tokenId}/auth`, {
            headers: { correlationId: v4() },
        });

        if (response.status !== 200) {
            throw new Error('fetchAuth error');
        }

        const payload = parsePayloadFromJWT(response.data.smart_auth);
        const tenantId = payload.tenantId ? payload.tenantId : 'adt-res';
        const avs01 = payload.avs01 ? payload.avs01 : false;
        localStorage.setItem('tenant_id', tenantId);
        localStorage.setItem('api_Token', response.data.smart_auth);
        localStorage.setItem('avs01', avs01);
        setShowHomePage(true);
    };

    if (showHomePage) {
        return <Home />;
    } else {
        return <LoadingScreen />;
    }
};

export default Main;
